import React from 'react';
import { MAIN_MOCKUP_URL } from '../data/assets';
import { CycleMark } from './CycleMark';
type ProductStackProps = {
  label?: string;
  className?: string;
};
const volumes = [{
  n: '06',
  t: 'Service Paperwork & Accounts',
  c: 'bg-bark'
}, {
  n: '05',
  t: 'Water, Scale & Sanitation',
  c: 'bg-sky'
}, {
  n: '04',
  t: 'Refrigeration & Environment',
  c: 'bg-sys-refrig'
}, {
  n: '03',
  t: 'Component Testing Bench',
  c: 'bg-moss'
}, {
  n: '02',
  t: 'Symptom-to-Part Flowcharts',
  c: 'bg-ember'
}, {
  n: '01',
  t: 'Read the Machine',
  c: 'bg-sky'
}];

/**
 * Imagen de producto. Si hay mockup principal (data/assets.ts) se usa ese;
 * si no, una pila de las 6 tapas horizontales dibujada con la identidad.
 */
export function ProductStack({
  label = '6 volumes · 124 field cards',
  className = ''
}: ProductStackProps) {
  if (MAIN_MOCKUP_URL) {
    return <img src={MAIN_MOCKUP_URL} alt="The six Ice Machine Diagnostic Pro volumes and five bonuses" className={`mx-auto h-auto w-full rounded-2xl shadow-stack ring-1 ring-black/10 ${className}`} data-id="element-298" data-mp="w1dgvibjez39" />;
  }
  return <div className={`relative mx-auto aspect-[16/13] w-full max-w-[460px] ${className}`} role="img" aria-label="The six Ice Machine Diagnostic Pro volumes stacked" data-id="element-299" data-mp="1e1wrokfqmp4h">
      {volumes.map((vol, i) => {
      const isFront = i === volumes.length - 1;
      return <div key={vol.n} className="grid-dark absolute aspect-[16/10] w-[80%] overflow-hidden rounded-lg bg-forest-deep shadow-stack ring-1 ring-white/10" style={{
        top: `${i * 5.6}%`,
        left: `${i * 3.6}%`,
        zIndex: i
      }} data-id="element-300" data-mp="21saadkcfnbme" data-mpi={i}>
            <span className={`absolute inset-y-0 left-0 w-2 ${vol.c}`} data-id="element-301" data-mp="1sx430gxiklhr" />
            {isFront ? <div className="relative flex h-full flex-col justify-between py-[5%] pl-[8%] pr-[5%]" data-id="element-302" data-mp="1nyj9t1goj22t">
                <CycleMark className="pointer-events-none absolute -right-[6%] -top-[10%] h-[70%] w-auto text-sky/30" data-id="element-303" data-mp="2gp1cw2hel3g8" />
                <div className="relative" data-id="element-304" data-mp="2zkruhag25mzt">
                  <p className="text-[8px] font-bold uppercase tracking-[2px] text-sky sm:text-[10px]" data-id="element-305" data-mp="2zltei4f1xjto">
                    Ice Machine Diagnostic Pro · Volume 01
                  </p>
                  <p className="mt-1 font-display text-[22px] uppercase leading-none text-paper sm:text-[30px]" data-id="element-306" data-mp="2qs6qj0h35kv1">
                    Read the Machine
                  </p>
                  <p className="mt-1 max-w-[80%] text-[9px] leading-snug text-paper/70 sm:text-[11px]" data-id="element-307" data-mp="2gu91iarejk1d">
                    The Freeze-or-Harvest Split &amp; First-15 Triage
                  </p>
                </div>
                <div className="relative flex flex-wrap gap-1" data-id="element-308" data-mp="27v5gv2cl6wkr">
                  {['15 FPC', '6 WS', '1 pocket card'].map(b => <span key={b} className="rounded border border-paper/25 px-1.5 py-0.5 font-mono text-[7px] font-semibold uppercase text-paper/80 sm:text-[9px]" data-id="element-309" data-mp="2bxs1ojaubh8g">
                      {b}
                    </span>)}
                  <span className="ml-auto flex items-center gap-1" data-id="element-310" data-mp="1ukafdapsdy6c">
                    {['bg-sys-water', 'bg-sys-refrig', 'bg-sys-harvest', 'bg-sys-controls'].map(c => <span key={c} className={`h-2 w-2 rounded-full ${c}`} data-id="element-311" data-mp="24dr8eci3n98y" />)}
                  </span>
                </div>
              </div> : <div className="flex items-baseline gap-2 py-[2.5%] pl-[8%] pr-[4%]" data-id="element-312" data-mp="2e9b4aywny7xp">
                <span className="font-mono text-[8px] font-semibold text-sky sm:text-[10px]" data-id="element-313" data-mp="29c2imocb3lrp">
                  VOL {vol.n}
                </span>
                <span className="truncate font-display text-[11px] uppercase text-paper/85 sm:text-sm" data-id="element-314" data-mp="2n8y4xihkj9pp">
                  {vol.t}
                </span>
              </div>}
          </div>;
    })}
      <span className="absolute bottom-0 left-1/2 z-20 -translate-x-1/2 whitespace-nowrap rounded-full bg-ember px-4 py-2 text-[12px] font-bold uppercase tracking-wide text-pine shadow-card" data-id="element-315" data-mp="syufgrisnzwb">
        {label}
      </span>
    </div>;
}